import { render, staticRenderFns } from "./settings-lists-orderstages.vue?vue&type=template&id=a4c32e02&"
import script from "./settings-lists-orderstages.ts?vue&type=script&lang=ts&"
export * from "./settings-lists-orderstages.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports